module.exports = __webpack_public_path__ + "static/forecast/weather/nightheavysnow-a77381f490730d6ef2a3af9266ef2d73.svg";